import { Component, Input, Output, ElementRef, OnInit, OnChanges, AfterViewInit, EventEmitter } from '@angular/core';
import { WindowService } from "../services/window.service";
import { Logger } from "../utils/logger";

@Component({
    selector: 'price_bage',
    templateUrl: "./price_bage.component.html"
})
export class PriceBage implements OnInit, AfterViewInit, OnChanges {

    @Input("show")
    // public needShow = true;
    public isShown = true;

    public isFited = false;


    @Input()
    public total: number = 0;

    @Input('configuration')
    public mainConfiguration;

    @Output('onShowDetails')
    public onShowDetails: EventEmitter<boolean> = null;

    public majorDigits = [];
    public minorDigits = [];


    constructor(public el: ElementRef, public windowService: WindowService, public logger: Logger) {
        this.onShowDetails = new EventEmitter<boolean>();
    }

    ngAfterViewInit(): any {

    }

    ngOnInit(): any {
        this.fit();
        this.windowService.addResizeEventListener(() => {
            this.fit();
        })
    }
    ngOnChanges(changes: any): any {
        // this.logger.debug(changes);
        if (typeof changes.total !== 'undefined') {
            if (typeof changes.total.currentValue !== 'undefined') {
                let total = changes.total.currentValue;
                let major = Math.floor(total / 1000).toString();
                let minor = Math.round(total % 1000).toString();
                if (total >= 1000) {
                    this.majorDigits = major.split('');
                } else {
                    this.majorDigits = [];
                }
                this.minorDigits = minor.split('');
                if (this.minorDigits.length < 3) {
                    for (let i = this.minorDigits.length; i < 3; i++) {
                        this.minorDigits.unshift("0");
                    }
                }
                this.fit();
            }
        }//else
        //     if (typeof changes.needShow !== 'undefined') {
        //     if (changes.needShow.currentValue && changes.needShow.currentValue !== changes.needShow.previousValue) {
        //         this.show();
        //     } else {
        //         this.hide();
        //     }
        // }
    }


    fit() {
        let zoom = this.windowService.getScreenZoom();
        let container = this.el.nativeElement.querySelector('.price-bage');

        if (container) {
            if (this.isFited) {
                return;
            }
            this.isFited = true;
            let screenWidth = this.windowService.getScreenWidth();
            let screenHeight = this.windowService.getScreenHeight();
            let mainContainerWidth = this.windowService.getMainContainerWidth();
            let aspectRatio = this.windowService.getAspectRatio();
            let realAspectRatio = this.windowService.getRealAspectRatio();

            // alert(screenWidth + "x"+ screenHeight);

            // alert(mainContainerWidth)
            // container.style.marginRight = -1*(this.windowService.convertSize((mainContainerWidth/2) - 20))+'px';
            container.style.marginRight = -1 * (this.windowService.convertSize((mainContainerWidth / 2) - 20)) + 'px';
        }

    }

    hide() {
        // let s = this.el.nativeElement;
        // this.animator.setType("fadeOut").hide(s).then(()=> {
        //     this.isShown = false;
        // });
    }

    show() {
        // this.isShown = true;
        // let s = this.el.nativeElement;
        // this.animator.setType("fadeIn").show(s).then(()=> {
        //
        // });
    }


    showDetails() {
        this.onShowDetails.emit(true);
    }

}



// WEBPACK FOOTER //
// ./src/app/price_bage/price_bage.component.ts